import { change } from 'redux-form'
import { LOCATION_FINDER_INPUT } from 'constant'

export const handleChooseAddressSuggestion = (form, { place }) => dispatch => {
  dispatch(change(form, LOCATION_FINDER_INPUT, place))
}
